import api from 'service/api'

const dponetAPI = api.create('dponet')

const get = async ({ profileId = '', ...params }) => {
  return await dponetAPI.get(`/backoffice/advisor_profiles/${profileId}`, {
    params,
  })
}

const create = async ({ ...data }) => {
  return await dponetAPI.post('/backoffice/advisor_profiles', data)
}

const edit = async ({ profileId = '', ...data }) => {
  return await dponetAPI.put(`/backoffice/advisor_profiles/${profileId}`, data)
}

const changeStatus = async ({ profileId }) => {
  return await dponetAPI.put(
    `/backoffice/advisor_profiles/${profileId}/change_status`,
  )
}

const advisorProfiles = {
  get,
  create,
  edit,
  changeStatus,
}

export default advisorProfiles
